import { MultiselectHitType } from "src/types/Algolia";
import { cloneDeep } from "lodash-es";

export default function findAlgoliaCategoriesTreeNode(
  tree: MultiselectHitType[],
  value: string,
  key: keyof MultiselectHitType
): MultiselectHitType | null {
  const stack = cloneDeep(tree);
  while (stack.length) {
    const node = stack.shift();
    if (node?.[key] === value) return node;
    stack.push(...(node?.items || []));
  }
  return null;
}
